/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Downloads_Dropdown_WindowsInputs */

const en_downloads_dropdown_windows = /** @type {(inputs: Downloads_Dropdown_WindowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Windows`)
};

const es_downloads_dropdown_windows = /** @type {(inputs: Downloads_Dropdown_WindowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Windows`)
};

/**
* | output |
* | --- |
* | "Windows" |
*
* @param {Downloads_Dropdown_WindowsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const downloads_dropdown_windows = /** @type {((inputs?: Downloads_Dropdown_WindowsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Downloads_Dropdown_WindowsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_downloads_dropdown_windows(inputs)
	return en_downloads_dropdown_windows(inputs)
});